import { supabase } from '@/integrations/supabase/client';
import Logger from '@/utils/logger';
import type { ClientNote } from '@/types/client';
import { requireAuthUser } from './authHelpers';

const SERVICE_COMPONENT = 'clientNotesService';

export async function fetchClientNotes(clientId: string): Promise<ClientNote[]> {
  const { data, error } = await supabase
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .from('client_notes' as any)
    .select('*')
    .eq('client_id', clientId)
    .order('pinned', { ascending: false })
    .order('created_at', { ascending: false });

  if (error) {
    Logger.error('Failed to fetch client notes', error, { component: SERVICE_COMPONENT, clientId });
    throw error;
  }
  return (data || []) as unknown as ClientNote[];
}

export async function createClientNote(
  clientId: string,
  content: string
): Promise<ClientNote> {
  const ownerId = await requireAuthUser();

  const { data, error } = await supabase
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .from('client_notes' as any)
    .insert({ client_id: clientId, content, owner_id: ownerId })
    .select()
    .single();

  if (error) {
    Logger.error('Failed to create client note', error, { component: SERVICE_COMPONENT, clientId });
    throw error;
  }
  return data as unknown as ClientNote;
}

export async function updateClientNote(
  noteId: string,
  updates: { content?: string; pinned?: boolean }
): Promise<ClientNote> {
  const { data, error } = await supabase
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .from('client_notes' as any)
    .update({ ...updates, updated_at: new Date().toISOString() })
    .eq('id', noteId)
    .select()
    .single();

  if (error) {
    Logger.error('Failed to update client note', error, { component: SERVICE_COMPONENT, noteId });
    throw error;
  }
  return data as unknown as ClientNote;
}

export async function deleteClientNote(noteId: string): Promise<void> {
  const { error } = await supabase
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .from('client_notes' as any)
    .delete()
    .eq('id', noteId);

  if (error) {
    Logger.error('Failed to delete client note', error, { component: SERVICE_COMPONENT, noteId });
    throw error;
  }
}
